export { CardSmall } from '@/entities/category/ui/cardSmall/CardSmall';
